import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {apiUrl} from '../../lib/api-base.js';
import styles from './auth-modal.css';

class AuthModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            mode: 'signin',
            username: '',
            email: '',
            password: '',
            confirmPassword: '',
            error: '',
            isSubmitting: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleOverlayClick = this.handleOverlayClick.bind(this);
    }
    handleOverlayClick (e) {
        if (e.target === e.currentTarget) {
            this.props.onClose();
        }
    }
    async handleSubmit (e) {
        e.preventDefault();
        this.setState({error: '', isSubmitting: true});

        const {mode, username, email, password, confirmPassword} = this.state;

        if (mode === 'signup') {
            if (!username || !email || !password) {
                this.setState({error: 'All fields are required', isSubmitting: false});
                return;
            }
            if (password !== confirmPassword) {
                this.setState({error: 'Passwords do not match', isSubmitting: false});
                return;
            }
            if (password.length < 6) {
                this.setState({error: 'Password must be at least 6 characters', isSubmitting: false});
                return;
            }
            try {
                const res = await fetch(apiUrl('/api/auth/register'), {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'include',
                    body: JSON.stringify({username, email, password})
                });
                const text = await res.text();
                let data;
                try {
                    data = JSON.parse(text);
                } catch {
                    this.setState({error: 'Server error. Please try again.', isSubmitting: false});
                    return;
                }
                if (!res.ok) {
                    this.setState({error: data.error || 'Registration failed', isSubmitting: false});
                    return;
                }
                if (this.props.onSuccess) this.props.onSuccess();
                this.props.onClose();
            } catch {
                this.setState({error: 'Could not connect to server. Please try again.', isSubmitting: false});
            }
        } else {
            if (!username || !password) {
                this.setState({error: 'Username and password are required', isSubmitting: false});
                return;
            }
            try {
                const res = await fetch(apiUrl('/api/auth/login'), {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'include',
                    body: JSON.stringify({username, password})
                });
                const text = await res.text();
                let data;
                try {
                    data = JSON.parse(text);
                } catch {
                    this.setState({error: 'Server error. Please try again.', isSubmitting: false});
                    return;
                }
                if (!res.ok) {
                    this.setState({error: data.error || 'Login failed', isSubmitting: false});
                    return;
                }
                if (this.props.onSuccess) this.props.onSuccess();
                this.props.onClose();
            } catch {
                this.setState({error: 'Could not connect to server. Please try again.', isSubmitting: false});
            }
        }
    }
    render () {
        const {mode, username, email, password, confirmPassword, error, isSubmitting} = this.state;
        const isSignUp = mode === 'signup';

        const modalElement = (
            <div
                className={styles.modalOverlay}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 999999,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    padding: '1.5rem',
                    boxSizing: 'border-box'
                }}
                onClick={this.handleOverlayClick}
            >
                <div
                    className={styles.modalContent}
                    style={{
                        margin: 'auto',
                        maxWidth: '92vw',
                        maxHeight: '85vh',
                        boxSizing: 'border-box'
                    }}
                >
                    <div className={styles.modalInner}>
                        <button
                            className={styles.closeButton}
                            onClick={this.props.onClose}
                        >
                            {'×'}
                        </button>

                        <h2 className={styles.modalTitle}>
                            {isSignUp ? 'Create Account' : 'Welcome Back'}
                        </h2>
                        <p className={styles.modalSubtitle}>
                            {isSignUp ? 'Join BlockJO to save your projects' : 'Sign in to your BlockJO account'}
                        </p>

                        <div className={styles.tabRow}>
                            <button
                                className={`${styles.tabButton} ${!isSignUp ? styles.active : ''}`}
                                onClick={() => this.setState({mode: 'signin', error: ''})}
                            >
                                Sign In
                            </button>
                            <button
                                className={`${styles.tabButton} ${isSignUp ? styles.active : ''}`}
                                onClick={() => this.setState({mode: 'signup', error: ''})}
                            >
                                Sign Up
                            </button>
                        </div>

                        {error && (
                            <div className={styles.errorMessage}>{error}</div>
                        )}

                        <form onSubmit={this.handleSubmit}>
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel}>
                                    {isSignUp ? 'Username' : 'Username or Email'}
                                </label>
                                <input
                                    className={styles.formInput}
                                    type="text"
                                    value={username}
                                    onChange={e => this.setState({username: e.target.value})}
                                    placeholder={isSignUp ? 'Choose a username' : 'Enter username or email'}
                                    autoComplete={isSignUp ? 'username' : 'username'}
                                />
                            </div>

                            {isSignUp && (
                                <div className={styles.formGroup}>
                                    <label className={styles.formLabel}>Email</label>
                                    <input
                                        className={styles.formInput}
                                        type="email"
                                        value={email}
                                        onChange={e => this.setState({email: e.target.value})}
                                        placeholder="Enter your email"
                                        autoComplete="email"
                                    />
                                </div>
                            )}

                            <div className={styles.formGroup}>
                                <label className={styles.formLabel}>Password</label>
                                <input
                                    className={styles.formInput}
                                    type="password"
                                    value={password}
                                    onChange={e => this.setState({password: e.target.value})}
                                    placeholder={isSignUp ? 'Create a password' : 'Enter your password'}
                                    autoComplete={isSignUp ? 'new-password' : 'current-password'}
                                />
                            </div>

                            {isSignUp && (
                                <div className={styles.formGroup}>
                                    <label className={styles.formLabel}>Confirm Password</label>
                                    <input
                                        className={styles.formInput}
                                        type="password"
                                        value={confirmPassword}
                                        onChange={e => this.setState({confirmPassword: e.target.value})}
                                        placeholder="Confirm your password"
                                        autoComplete="new-password"
                                    />
                                </div>
                            )}

                            <button
                                className={styles.submitButton}
                                type="submit"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Please wait...' : (isSignUp ? 'Create Account' : 'Sign In')}
                            </button>
                        </form>

                        <div className={styles.divider}>
                            <div className={styles.dividerLine} />
                            <span className={styles.dividerText}>or</span>
                            <div className={styles.dividerLine} />
                        </div>

                        <div className={styles.oauthButtons}>
                            <a className={styles.oauthButton} href={apiUrl('/api/auth/google')}>
                                <svg className={styles.oauthIcon} viewBox="0 0 24 24">
                                    <path
                                        fill="#4285F4"
                                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
                                    />
                                    <path
                                        fill="#34A853"
                                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                    />
                                    <path
                                        fill="#FBBC05"
                                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                    />
                                    <path
                                        fill="#EA4335"
                                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                    />
                                </svg>
                                {'Sign in with Google'}
                            </a>
                            <a className={styles.oauthButton} href={apiUrl('/api/auth/microsoft')}>
                                <svg className={styles.oauthIcon} viewBox="0 0 24 24">
                                    <rect fill="#F25022" x="1" y="1" width="10" height="10" />
                                    <rect fill="#7FBA00" x="13" y="1" width="10" height="10" />
                                    <rect fill="#00A4EF" x="1" y="13" width="10" height="10" />
                                    <rect fill="#FFB900" x="13" y="13" width="10" height="10" />
                                </svg>
                                {'Sign in with Microsoft'}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (typeof document !== 'undefined' && document.body) {
            return ReactDOM.createPortal(modalElement, document.body);
        }
        return modalElement;
    }
}

AuthModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func
};

export default AuthModal;
